/* eslint-disable no-confusing-arrow, @typescript-eslint/ban-types */
export const isDefined = (value: any): boolean => typeof value !== 'undefined';

export const isNull = (value: any): boolean => value === null;

export const isObject = (value: any): boolean => value !== null && typeof value === 'object';

export const isEmpty = (value: any): boolean => value === '';

export const isValidNumber = (value: any): boolean => /^\d+$/.test(value);

export const validNameRegex = (value: string): boolean => /[^a-zA-Z\s]$/.test(value);

export const validbsbRegex = (value: string): boolean => /^\d{6}$/.test(value);

export const validRemIDRegex = (value: string): boolean => /[^a-zA-Z0-9]$/.test(value);

export const validDateRegex = (value: string): boolean => /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[012])\/(19|20)\d\d$/.test(value);
